import { render, staticRenderFns } from "./ShipmentOrderQuery.vue?vue&type=template&id=a01bf8b4"
import script from "./ShipmentOrderQuery.vue?vue&type=script&lang=js"
export * from "./ShipmentOrderQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports